export const TIMEZONE = 'America/Santiago';
export const API = process.env.REACT_APP_BASE_FULL_API;
export const API_V3 = process.env.REACT_APP_BASE_FULL_API_V3;
